import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { reset } from 'ol/transform';
import { getUtcToLocalByFormat } from '@awp/helpers/utilsReact';
import { FormDatePicker } from '../Common/AwpFormInputs';
import { Crud } from '@awp/shared/Crud';
//import { pt } from 'date-fns/locale/pt';

const getNext30MinuteMark = (dateStamp = null) => {
  const now = dateStamp || new Date();
  const minutes = now.getMinutes();
  const next30Minutes = Math.ceil(minutes / 30) * 30;
  if (next30Minutes === 60) {
    now.setHours(now.getHours() + 1);
    now.setMinutes(0);
  } else {
    now.setMinutes(next30Minutes);
  }
  now.setSeconds(0);
  now.setMilliseconds(0);

  return getUtcToLocalByFormat(now.toISOString(), 'yyyy-MM-dd HH:mm');
};

const VMSDateModal = ({ showModal, setShowModal, saveDateTime }) => {
  const [resetTime, setResetTime] = useState(getNext30MinuteMark());

  const crud = new Crud('Set Date/Time');

  const close = () => {
    setShowModal(false);
    setResetTime(getNext30MinuteMark()); //reset time
  };

  const save = () => {
    close();
    saveDateTime(new Date(resetTime));
  };

  const onChange = (value) => {
    setResetTime(value);
  };

  //console.log(new Date(resetTime));

  return (
    <Modal
      show={showModal}
      animation={false}
      onHide={close}
      backdrop="static"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>{crud.getModalTitle()}</Modal.Header>
      <Modal.Body>
        <DatePicker
          selected={new Date(resetTime)}
          className="form-control input-sm"
          dateFormat={['yyyy-MM-dd HH:mm', 'yyyy-MM-dd', 'yyyyMMdd']}
          showTimeSelect={true} //control time selection
          showTime={{ isEnabled: true }}
          closeOnSelect={true}
          timeFormat={'HH:mm'}
          timeIntervals={30}
          onChange={onChange}
          autoFocus={false}
        />
        {/* <DatePicker
          locale="pt"
          allowSameDay={true}
          className="form-control input-sm"
          name="reset-datetime"
          closeOnSelect={true}
          showTimeSelect={true}
          timeIntervals={30}
          showIcon={true}
          dateFormat={'yyyy-MM-dd hh:mm'}
          onChange={(val) => {
            //console.log(val);
            setResetTime(val.toISOString().slice(0, 16).replace('T', ' '));
          }}
          //placeholderText={new Date()}
          showTime={{ isEnabled: false }}
          selected={resetTime}
        /> */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={save}>
          Save
        </Button>
        <Button variant="danger" onClick={close}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

VMSDateModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  saveDateTime: PropTypes.func,
};

export default VMSDateModal;
